<template>
    <v-main>
        <div class="stepper-3">
            <div id="move-step3">
                <StepperBar v-if="registrationFormDetail" :stepOn="StepperType" :stepper="3" />
            </div>
        </div>
        <v-container class="spacing-playground form-margin-top">
            <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    md="7"
                    class="d-flex justify-md-end justify-sm-center"
                >
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                        v-if="waitStatus"
                    >
                        <v-card-text class="py-5">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="pt-16">
                                    <v-img
                                        :src="
                                            require('../../src/assets/clock.svg')
                                        "
                                        contain
                                        height="60"
                                    />
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="py-0">
                                    <div class="prompt-title-page">
                                        {{$t("message.step3.status.waitAnnouncement")}}
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="d-flex justify-center col-width-content-scale-2"
                                >
                                    <div class="form-label-400 text-center width-content-scale-2">
                                        {{ $t('message.step3.content.message1')}}
                                    </div>
                                </v-col>

                                <!-- notation -->
                                <v-col v-if="notation"
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="d-flex justify-center col-width-content-scale-2"
                                >
                                    <div class="notation-text">
                                        <span> {{ notation  }} </span>
                                    </div>
                                </v-col>

                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="pb-16 text-center"
                                >
                                    <div
                                        class="pa-0 pb-7 step3__text__size18"
                                    >
                                        {{ $t('message.step3.content.question')}}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                        v-else-if="authorizeStatus"
                    >
                        <v-card-text class="pt-11 pb-10 px-9">
                            <v-row class="pb-3">
                                <v-col cols="12" md="12" sm="12" class="pb-1">
                                    <v-img
                                        :src="
                                            require('../../src/assets/right.svg')
                                        "
                                        contain
                                        height="60"
                                    />
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="pb-0">
                                    <div class="prompt-title-page">
                                        {{$t("message.step3.status.qualified")}}
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    sm="12"
                                    class="text-center d-flex justify-center col-width-content-scale"
                                >
                                    <div class="form-label-400 width-content-scale">
                                        {{ $t('message.step3.content.message2')}}
                                    </div>
                                </v-col>
                            </v-row>
                            <div class="px-md-16 px-2">
                                <v-row>
                                    <v-col>
                                        <div class="prompt-title">
                                            {{ $t('message.step3.content.dayExamination')}}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.examDate')}}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                            {{ examDate }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.examPeriod')}}
                                        </div>
                                        <div
                                            v-if="registrationFormDetail?.exam_start_time_phase1"
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.exam_start_time_phase1
                                            }}
                                            {{ $t('message.formSummit.time')}}
                                        </div>
                                        <div
                                            v-else
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                        -
                                        </div>
                                    </v-col>
                                    <!-- <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.testVenue')}}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.exam_location
                                            }}
                                        </div>
                                    </v-col> -->
                                    <!-- <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.firstExamPeriod')}}
                                        </div>
                                        <div
                                            v-if="registrationFormDetail?.exam_start_time_phase1 && registrationFormDetail?.exam_end_time_phase1"
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.exam_start_time_phase1
                                            }} -
                                            {{
                                                registrationFormDetail?.exam_end_time_phase1
                                            }}
                                            {{ $t('message.formSummit.time')}}
                                        </div>
                                        <div
                                            v-else
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                        -
                                        </div>
                                    </v-col> -->
                                    <!-- <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.secondExamPeriod')}}
                                        </div>
                                        <div
                                            v-if="registrationFormDetail?.exam_start_time_phase2 && registrationFormDetail?.exam_end_time_phase2"
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.exam_start_time_phase2
                                            }} -
                                            {{
                                                registrationFormDetail?.exam_end_time_phase2
                                            }}
                                            {{ $t('message.formSummit.time')}}
                                        </div>
                                        <div
                                            v-else
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                        >
                                        -
                                        </div>

                                    </v-col> -->
                                </v-row>
                                <v-row>
                                    <v-col class="pt-6 ">
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                        <div class="prompt-title">
                                            {{ $t('message.step3.content.candidateInformation')}}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="py-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step4.content.name')  }}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                            v-if="student?.student_detail"
                                        >
                                            {{ studentFullName }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step4.content.classroom')  }}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                            v-if="student?.register_plan"
                                        >
                                            {{  student?.register_plan
                                                    ?.student_year
                                                    ?.[`student_year_name_${locale}`]
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step4.content.curriculum')  }}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                            v-if="student?.register_plan"
                                        >
                                            {{  student?.register_plan
                                                    ?.program
                                                    ?.[`program_name_${locale}`]
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="8"
                                        sm="8"
                                        md="12"
                                        class="pb-2"
                                    >
                                        <div
                                            class="step3__text__size18"
                                        >
                                            {{ $t('message.step3.content.question')}}
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card
                        max-width="690"
                        elevation="0"
                        style="border-radius: 10px"
                        v-else-if="unauthorizeStatus"
                    >
                        <v-card-text class="pt-11 pb-10 px-9">
                            <v-row class="pb-3">
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    class="pb-4"
                                >
                                    <v-img
                                        :src="
                                            require('../../src/assets/wrong.svg')
                                        "
                                        contain
                                        height="60"
                                    />
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    class="d-flex justify-center col-width-content-scale"
                                    style="padding: 0 7rem"
                                >
                                    <div class="prompt-title-page width-col-width-content-scale">
                                        {{$t("message.step3.status.noQualified")}}
                                    </div>
                                </v-col>
                            </v-row>
                            <div class="px-md-16 px-2">
                                <v-row>
                                    <v-col class="pt-6">
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                        <div class="prompt-title">
                                            {{ $t('message.step3.content.candidateInformation')}}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="py-0"
                                    >
                                        <div class="pa-0 ma-0 prompt-caption">
                                            {{ $t('message.step4.content.name')  }}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                            v-if="student?.student_detail"
                                        >
                                            {{ studentFullName }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step4.content.classroom')  }}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                            v-if="student?.register_plan"
                                        >
                                            {{  student?.register_plan
                                                    ?.student_year
                                                    ?.[`student_year_name_${locale}`]
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="py-0 pr-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step4.content.curriculum') }}
                                        </div>
                                        <div
                                            class="px-0 mt-0 pt-1 pb-3 step3__text__size18"
                                            v-if="student?.register_plan"
                                        >
                                            {{  student?.register_plan
                                                    ?.program
                                                    ?.[`program_name_${locale}`]
                                            }}
                                        </div>
                                    </v-col>

                                    <!-- notation -->
                                    <v-col v-if="notation"
                                        cols="12"
                                        md="12"
                                        sm="12"
                                        class="d-flex justify-center col-width-content-scale-2"
                                    >
                                        <div class="notation-text">
                                            <span> {{ notation  }} </span>
                                        </div>
                                    </v-col>

                                    <v-col
                                        cols="8"
                                        sm="8"
                                        md="12"
                                    >
                                        <div
                                            class="pb-0 step3__text__size18"
                                        >
                                            {{ $t('message.step3.content.question')}}
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="5"
                    id="step-sidebar"
                    class="ma-0 px-0"
                >
                    <v-card id="step-sidebar-card">
                        <v-card-text>
                            <v-row>
                                <v-col cols="10" class="d-flex align-center pb-0 pt-1">
                                    <div class="pa-0 prompt-title">
                                        {{ $t('message.formSummit.applicationForm')}}
                                    </div>
                                </v-col>
                                <v-col cols="2" class="pb-1 pt-1">
                                    <v-btn icon @click="closeBar" class="d-flex align-center"
                                        ><v-icon id="dropbar-icon"
                                            >mdi-menu-down</v-icon
                                        ></v-btn
                                    >
                                </v-col>
                            </v-row>
                            <template v-if="this.closeActive">
                                <v-row>
                                    <v-col cols="12" class="py-0 mt-c-n1">
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.formSummit.school')}}
                                        </div>
                                    </v-col >
                                    <v-col cols="12" class="pt-1 pb-0">
                                        <div
                                            class="pa-0 mt-0 step3__text__size18"
                                        >
                                            {{ organization?.[`name_${locale}`] }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="py-c-14">
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                        cols="4"
                                        sm="6"
                                        md="3"
                                        class="pb-c-14 pt-0"
                                        v-if="waitStatus && registrationFormDetail?.has_register_fee"
                                        ><div class="pa-0 prompt-title">
                                            {{ $t('message.formSummit.status')}}
                                        </div></v-col
                                    >
                                    <v-col
                                        cols="8"
                                        sm="6"
                                        md="9"
                                        class="pb-c-14 pt-0"
                                        v-if="waitStatus && registrationFormDetail?.has_register_fee"
                                    >
                                        <div class="pa-0 prompt-title d-flex justify-end">
                                            <v-chip
                                                class="ma-0"
                                                color="#EBEBEC"
                                            >
                                                <v-img
                                                    class="mr-1"
                                                    :src="
                                                        require('@/assets/money-circle.svg')
                                                    "
                                                    contain
                                                    left
                                                />
                                                <div class="prompt-chip pt-1">
                                                    {{ $t('message.step3.status.successfulPayment')}}
                                                </div>
                                            </v-chip>
                                        </div>
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 pb-c-14"
                                        v-if="
                                            authorizeStatus || unauthorizeStatus
                                        "
                                        ><div class="pa-0 prompt-title">
                                            {{ $t('message.formSummit.status')  }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 pb-c-14"
                                        v-if="
                                            authorizeStatus || unauthorizeStatus
                                        "
                                    >
                                        <div class="pa-0 prompt-title d-flex justify-end">
                                            <v-chip
                                                class="ma-0"
                                                color="#EBEBEC"
                                                v-if="authorizeStatus"
                                            >
                                                <v-icon color="#00C487" left
                                                    >mdi-checkbox-marked-circle</v-icon
                                                >
                                                <div class="prompt-chip pt-1">
                                                    {{ $t('message.step3.status.qualified')}}
                                                </div>
                                            </v-chip>
                                            <v-chip
                                                class="ma-0"
                                                color="#EBEBEC"
                                                v-if="unauthorizeStatus"
                                            >
                                                <v-icon color="#FF544A" left
                                                    >mdi-close-circle</v-icon
                                                >
                                                <div class="prompt-chip pt-1">
                                                    {{ $t('message.step3.status.noQualified')}}
                                                </div>
                                            </v-chip>
                                        </div>
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 pr-0 mb-0 pb-c-14"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.announcementDate')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-0 pt-1 step3__text__size18"
                                        >
                                            {{ examAuthorizeAnnouncementDate }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.formSummit.timeline')  }}
                                        </div>
                                        <div
                                            class="pb-0 mt-0 pt-1 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.exam_authorize_announcement_time
                                            }}
                                            {{ $t('message.formSummit.time')  }}
                                        </div>
                                    </v-col>

                                    <!-- print applicant from  -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="py-c-14"
                                        v-if="!authorizeStatus"
                                    >
                                        <v-btn
                                            class="prompt-"
                                            block
                                            rounded
                                            color="#FF9800"
                                            outlined
                                            dark
                                            height="40"
                                            style="
                                                font-weight: 400;
                                                font-size: 18px;
                                                line-height: 24px;
                                                letter-spacing: 0.05rem;
                                                box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                            "
                                            @click="downloadCandidateInfo(false)"
                                        >
                                            <v-icon color="orange" left
                                                >mdi-download</v-icon>
                                                {{ $t('message.step3.content.candidateInfoDownload')}}
                                        </v-btn>
                                    </v-col>

                                </v-row>
                            </template>
                            <v-row v-if="authorizeStatus">
                                <template v-if="this.closeActive">
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="py-0 my-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.announcementFirstResult')}}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            class="pa-0 mt-0 pt-1 step3__text__size18"
                                        >
                                            {{ announcementExamResultDate }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            class="pa-0 mt-0 pt-1 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.announcement_exam_result_time
                                            }}
                                            {{ $t('message.formSummit.time')  }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="py-0 my-0"
                                    >
                                        <div class="pa-0 prompt-caption">
                                            {{ $t('message.step3.content.announcementReserveResult')}}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            class="pb-0 mt-0 pt-1 step3__text__size18"
                                        >
                                            {{
                                                reservedAnnouncementExamResultDate
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="pt-0 my-0 pb-c-14"
                                    >
                                        <div
                                            class="pb-0 mt-0 pt-1 step3__text__size18"
                                        >
                                            {{
                                                registrationFormDetail?.reserved_announcement_exam_result_time
                                            }}
                                            {{ $t('message.formSummit.time')  }}
                                        </div>
                                    </v-col>
                                </template>
                                <!-- <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    class="py-c-14"
                                >
                                    <v-btn
                                        class="prompt-"
                                        block
                                        rounded
                                        color="#FF9800"
                                        outlined
                                        dark
                                        height="40"
                                        style="
                                            font-weight: 400;
                                            font-size: 18px;
                                            line-height: 24px;
                                            letter-spacing: 0.05rem;
                                            box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                        "
                                        @click="downloadCandidateInfo(true)"
                                    >
                                        <v-icon color="orange" left
                                            >mdi-download</v-icon>
                                            {{ $t('message.step3.content.applicationIDCard')}}
                                    </v-btn>
                                </v-col> -->
                            </v-row>
                            <v-row>
                                <template v-if="this.closeActive">
                                    <v-col class="pr-0 pt-c-14 d-flex align-center"
                                        ><div
                                            class="pa-0 mx-auto step3__text__size14"
                                        >
                                            Customer Service LINE
                                        </div></v-col
                                    >
                                    <v-col class="pt-c-14"
                                        ><v-img
                                            :src="
                                                require('../../src/assets/lineBtn.svg')
                                            "
                                            contain
                                            height="36"
                                        />
                                    </v-col>
                                </template>
                            </v-row>
                            <VueHtml2pdf
                                :manual-pagination="true"
                                :enable-download="true"
                                :pdf-quality="2"
                                pdf-orientation="portrait"
                                ref="DownloadComp"
                            >
                                <section slot="pdf-content">
                                    <TicketPart
                                        v-if="student && registrationFormDetail && organization"
                                        :registrationFormDetail="registrationFormDetail"
                                        :student="student"
                                        :organizationDetail="organization"
                                    />
                                </section>
                            </VueHtml2pdf>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="5" class="ma-0 px-0">
                    <div style="height: 480px" id="height-overflow"></div>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import StepperBar from "./StepperBar";
import * as services from "@/services";
import VueHtml2pdf from "vue-html2pdf";
import TicketPart from "@/components/fileElement/TicketPart";
import * as dateUtils from "@/utils/date";
import { RegistrationStatusEnum } from "@/constants";
import dayjs from 'dayjs';
import { genApplicationID, genApplicationData } from "@/utils/applicant";
import i18n from '@/i18n';
import { downloadEnrollmentFormPDF } from '@/utils/enrollmentFormPDF'

export default {
    name: "StepThree",
    components: { StepperBar, VueHtml2pdf, TicketPart },
    data: () => ({
        type: "success",
        closeActive: true,
        student: null,
        studentParents: [],
        id: null,
        organization: null,
    }),
    props: {
        registrationFormDetail: Object,
        student_id: Number,
        student_status: String,
    },
    computed: {
        locale(){
            return i18n.locale;
        },
        waitStatus() {
            // Date before exam announcement date
            let announcement_date = new Date(this.registrationFormDetail?.exam_authorize_announcement_date + " " + this.registrationFormDetail?.exam_authorize_announcement_time)
            if (dayjs(new Date()).isSameOrBefore(dayjs(announcement_date)))
                if( this.student_status === RegistrationStatusEnum.SUCCESSFUL_PAYMENT ||
                    this.student_status === RegistrationStatusEnum.REGISTER ||
                    this.student_status === RegistrationStatusEnum.EXAM_AUTHORIZE ||
                    this.student_status === RegistrationStatusEnum.EXAM_UNAUTHORIZE)
                return true;
            return false;
        },
        authorizeStatus() {
            // Date after exam announcement date and before result announcement date
            let announcement_date = new Date(this.registrationFormDetail?.exam_authorize_announcement_date + " " + this.registrationFormDetail?.exam_authorize_announcement_time)
            if ( (dayjs(announcement_date).isSameOrBefore(dayjs(new Date()))) )
                if(
                    this.student_status === RegistrationStatusEnum.EXAM_AUTHORIZE ||
                    this.student_status === RegistrationStatusEnum.EXAM_AUTHORIZE_BY_SYSTEM ||
                    this.student_status === RegistrationStatusEnum.PENDING_CONFIRMATION
                )
                return true;
            return false;
        },
        unauthorizeStatus() {
            let announcement_date = new Date(this.registrationFormDetail?.exam_authorize_announcement_date + " " + this.registrationFormDetail?.exam_authorize_announcement_time)
            if (this.student_status === RegistrationStatusEnum.EXAM_UNAUTHORIZE && (dayjs(announcement_date).isSameOrBefore(dayjs(new Date()))))
                return true;
            return false;
        },
        examDate() {
            let newDate = Date.parse(this.registrationFormDetail?.exam_date);
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        examAuthorizeAnnouncementDate() {
            let newDate = Date.parse(
                this.registrationFormDetail?.exam_authorize_announcement_date
            );
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        announcementExamResultDate() {
            let newDate = Date.parse(
                this.registrationFormDetail?.announcement_exam_result_date
            );
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        reservedAnnouncementExamResultDate() {
            let newDate = Date.parse(
                this.registrationFormDetail
                    ?.reserved_announcement_exam_result_date
            );
            if (newDate) return dateUtils.formatDateTimeLocale(newDate, i18n.locale);
            else return "";
        },
        StepperType() {
            if(this.registrationFormDetail != null && !(this.registrationFormDetail?.fee == 0 || this.registrationFormDetail?.fee == null))
                return true;
            else return false;
        },
        formatDateTimeRange(start, end) {
            if (!start && !end) return "-";
            return `${start} - ${end} น.`;
        },
        studentFullName(){
            return `${this.student?.student_detail?.prefix_id?.[`text_${this.locale}`]} ${this.student?.student_detail?.[`name_${this.locale}`]} ${this.student?.student_detail?.[`surname_${this.locale}`]}`
        },
        notation() {
            return (this.student_status === RegistrationStatusEnum.REGISTER || this.student_status === RegistrationStatusEnum.EXAM_UNAUTHORIZE) && this.student?.student_other_detail?.notation
        }
    },
    methods: {
        closeBar() {
            if (this.closeActive) {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(180deg)";
                document.getElementById("height-overflow").style.height =
                    "180px";
            } else {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(0deg)";
                document.getElementById("height-overflow").style.height =
                    "480px";
            }
            this.closeActive = !this.closeActive;
        },
        download() {
            this.$refs.DownloadComp.generatePdf();
        },
        async downloadCandidateInfo(isShowTicket) {
            try {
                this.$emit('loadingUpdate',1)
                const applicationID = genApplicationID(this.registrationFormDetail?.grade_level, this.student?.index_number)
                const filename = `enrollment_form_${applicationID}.pdf`
                downloadEnrollmentFormPDF(genApplicationData(this.student, this.studentParents, isShowTicket), filename)
            } catch (error) {
                console.error('Error previewing PDF:', error)
                this.$toast.error(error?.message ?? error);
            } finally {
                this.$emit('loadingUpdate',-1)
            }
        },
        async fetchInitStudentQuery() {
            try {
                this.$emit('loadingUpdate',1)
                const body = {
                    token: localStorage.getItem("token"),
                    query: {
                        // selects: {
                        //     student_detail: {
                        //         prefix_id: {
                        //             text_th: true,
                        //             text_en: true,
                        //         },
                        //         name_th: true,
                        //         surname_th: true,
                        //         name_en: true,
                        //         surname_en: true,
                        //         national_id: true,
                        //         student_img: true
                        //     },
                        //     register_plan: true,
                        //     student_other_detail: {
                        //         former_school_name: true,
                        //         former_school_province: true,
                        //         former_school_GPAX: true,
                        //         former_school_last_student_year: true,
                        //     },
                        // },
                        // relations: {
                        //     student_detail: {
                        //         prefix_id: true,
                        //     },
                        //     register_plan: {
                        //         program: true,
                        //         student_year: true,
                        //     },
                        //     student_other_detail: {
                        //         former_school_province: true,
                        //         former_school_last_student_year: true,
                        //     },
                        // },
                        selects: {
                            student_detail: true,
                            student_other_detail: true,
                            student_address_detail: true,
                            student_parent_detail: true,
                            register_plan: true,
                            register_form: {
                                id: true,
                            },
                        },
                        relations: {
                            student_address_detail: {
                                national_province: true,
                                national_district: true,
                                national_subdistrict: true,
                                current_province: true,
                                current_district: true,
                                current_subdistrict: true,
                            },
                            student_parent_detail: true,
                            student_detail: {
                                ethnicity: true,
                                nationality: true,
                                religion: true,
                                prefix_id: true,
                            },
                            student_other_detail: {
                                former_school_province: true,
                                former_school_district: true,
                                former_school_last_student_year: true,
                            },
                            register_plan: {
                                program: true,
                                student_year: true,
                            },
                            register_form: true,
                        },
                    },
                };
                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);
                this.student = data.student;
                if(this.student.student_detail.student_img){
                    let imageData = await services.getImageBase64FromUrl(this.student?.student_detail?.student_img)
                    this.student.student_detail['student_img_base64'] = imageData.data.data.data
                    this.student.student_detail['student_img'] = imageData.data.data.data
                }
                else{
                    this.student.student_detail['student_img_base64'] = null
                    this.student.student_detail['student_img'] = null
                }

                const register_form = await services.getRegistrationFormById(
                    this.student?.register_form?.id
                );
                this.student['register_form'] = register_form.data.data.registration_form

                let parentData = [];
                if (this.student.student_parent_detail?.id != undefined) {
                    const resParent = await services.getStudentParents(
                        this.student.student_parent_detail.id
                    );
                    parentData = resParent?.data?.data?.student_parents;
                }

                this.studentParents = parentData

                const res = await services.getOrganization();
                this.organization = res.data.data.organization;
            } finally{
                this.$emit('loadingUpdate',-1)
            }
        },
    },
    created() {
        this.fetchInitStudentQuery();
    },
};
</script>

<style scoped lang="scss">
.form-label-400{
    font-size: 18px;
}

.width-content-scale{
    width:300px;
}

.width-content-scale-2{
    width:350px;
}

.pb-c-14{
    padding-bottom: 14px;
}
.pt-c-14{
    padding-top: 14px;
}
.py-c-14{
    padding-top: 14px;
    padding-bottom: 14px;
}

@media only screen and (max-width: 600px) {
    .width-content-scale{
        width:100%;
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .col-width-content-scale{
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .col-width-content-scale-2{
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
}

.step3__text__size18{
    color: #37323c;
    font-family: 'Sarabun', sans-serif;
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.step3__text__size18__error{
    color: #ff544a;
    font-family: 'Sarabun', sans-serif;
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.step3__text__size14{
    color: #37323c;
    font-family: 'Sarabun', sans-serif;
    font-size: 14px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

.notation-text {
    min-width: 320px;
    border: 1px solid #ff544a;
    background-color: rgba(255, 84, 74, 0.1);
    border-radius: 10px;
    padding: 16px;
    font-family: 'Sarabun', sans-serif;
    font-size: 18px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
    color: #ff544a;
    // text-align: center;
    white-space: pre-wrap;
    word-wrap: break-word;
}

</style>
